import { MatTableDataSource } from '@angular/material/table';
import { AbstractControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export class AbstractControlDataSource<T> extends MatTableDataSource<T> {
	disconnected = new Subject<void>();

	constructor(readonly source: AbstractControl) {
		super(source.value);
		source.valueChanges
			.pipe(takeUntil(this.disconnected))
			.subscribe((values) => {
				this.data = values;
			});
	}

	disconnect() {
		this.disconnected.next();
		super.disconnect();
	}
}
